import {UNIT} from '@di-shared/const';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import ImageSelector from '@di-shared/features/common/ImageSelector';

function UbiSectionLoadingKr() {
  const {t} = useInferableTranslation();

  return (
    <section className="section section_ubi">
      <div className="section_container">
        <div className="section_container_header skeleton">
          <div className="container_header_title">
            <h3 className="label_medium_b">{t('T20019')}</h3>
            <strong className="title_xxsmall">{t('T10137')}</strong>
          </div>
          <div className="container_header_imgbox">
            <ImageSelector
              alt="ubi-discount-logo"
              kiaLightSrc={() => import('@di-shared/assets/img/home/ubi_discount_light.png')}
              kiaDarkSrc={() => import('@di-shared/assets/img/home/ubi_discount.png')}
              hyundaiLightSrc={() => import('@di-shared/assets/img/home/hyundai/ubi_discount_light.png')}
              hyundaiDarkSrc={() => import('@di-shared/assets/img/home/hyundai/ubi_discount.png')}
              genesisLightSrc={() => import('@di-shared/assets/img/home/genesis/ubi_discount_light.png')}
              genesisDarkSrc={() => import('@di-shared/assets/img/home/genesis/ubi_discount.png')}
            />
          </div>
        </div>
        <ul className="ubi_discount_list">
          <li className="ubi_discount_item skeleton">
            <div className="ubi_discount_icon">
              <span className="ic ic_fuel_efficiency_20px" />
            </div>
            <span className="ubi_discount_title">{t('T10138')}</span>
            <span className="ubi_discount_rate">
              {t('T10139')} <em className="text_emphasis">12.2</em>
              {UNIT.PERCENT}
            </span>

            <div className="section_container_box">
              <strong className="discount_info_title">{t('T10140')}</strong>
              <p className="discount_info_desc">
                안전운전 점수 75점을 달성하여 <br />
                최대 할인율인 18%를 할인 받을 수 있어요!
              </p>
              <div className="discount_info_progress">
                <div className="slider slider_progress">
                  <label
                    className="blind"
                    htmlFor="distanceProgress"
                  >
                    {t('T10141')}
                  </label>
                  <div className="slider_box">
                    <progress
                      className="slider_bar"
                      id="distanceProgress"
                      max="1000"
                      value="770"
                    />
                  </div>
                </div>
                <div className="progress_text">
                  <span className="progress_my">
                    <span className="blind">{t('T10142')}</span>
                    770km
                  </span>
                  <span className="progress_require">
                    <span className="blind">{t('T10143')}</span>
                    1,000km
                  </span>
                </div>
              </div>
            </div>
          </li>

          <li className="ubi_discount_item skeleton">
            <div className="ubi_discount_icon">
              <span className="ic ic_share_20px" />
            </div>
            <span className="ubi_discount_title">{t('T10144')}</span>
            <span className="ubi_discount_rate">
              {t('T10139')}
              <em className="text_emphasis">{12.2}</em>
              {UNIT.PERCENT}
            </span>
          </li>
          <li className="ubi_discount_item skeleton">
            <div className="ubi_discount_icon">
              <span className="ic ic_location_20px" />
            </div>
            <span className="ubi_discount_title">{t('T10145')}</span>
            <span className="ubi_discount_rate">
              {t('T10139')} <em className="text_emphasis">{12.2}</em>
              {UNIT.PERCENT}
            </span>
          </li>
          <li className="ubi_discount_item skeleton">
            <div className="ubi_discount_icon">
              <span className="ic ic_svm_all_20px" />
            </div>
            <span className="ubi_discount_title">{t('T10146')}</span>
            <span className="ubi_discount_rate">
              {t('T10139')} <em className="text_emphasis">{12.2}</em>
              {UNIT.PERCENT}
            </span>
          </li>
        </ul>
      </div>
    </section>
  );
}

export default UbiSectionLoadingKr;
